// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as CardValidations$OrcaPaymentPage from "../../shared-code/sdk-utils/validation/CardValidations.bs.js";

function updateCardBody(paymentMethodToken, nickName, cardHolderName) {
  let cardDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
    [
      "card_holder_name",
      cardHolderName
    ],
    [
      "nick_name",
      nickName
    ]
  ]);
  let paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
      "card",
      cardDetails
    ]]);
  return [
    [
      "payment_method_token",
      paymentMethodToken
    ],
    [
      "payment_method_data",
      paymentMethodData
    ]
  ];
}

function updateCVVBody(paymentMethodToken, cvcNumber) {
  let cardDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
      "card_cvc",
      cvcNumber
    ]]);
  let paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
      "card",
      cardDetails
    ]]);
  return [
    [
      "payment_method_token",
      paymentMethodToken
    ],
    [
      "payment_method_data",
      paymentMethodData
    ]
  ];
}

function vaultUpdateCVVBody(cvcNumber) {
  let cardDetails = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
      "card_cvc",
      cvcNumber
    ]]);
  let paymentMethodData = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
      "card",
      cardDetails
    ]]);
  return [[
      "payment_method_data",
      paymentMethodData
    ]];
}

function saveCardBody(cardNumber, month, year, cardHolderNameOpt, cvcNumber, cardBrand, nicknameOpt) {
  let cardHolderName = cardHolderNameOpt !== undefined ? Primitive_option.valFromOption(cardHolderNameOpt) : undefined;
  let nickname = nicknameOpt !== undefined ? nicknameOpt : "";
  let cardBody = [
    [
      "card_number",
      CardValidations$OrcaPaymentPage.clearSpaces(cardNumber)
    ],
    [
      "card_exp_month",
      month
    ],
    [
      "card_exp_year",
      year
    ],
    [
      "card_cvc",
      cvcNumber
    ]
  ];
  Core__Option.map(cardHolderName, name => {
    cardBody.push([
      "card_holder_name",
      name
    ]);
  });
  if (nickname !== "") {
    cardBody.push([
      "nick_name",
      nickname
    ]);
  }
  return [
    [
      "payment_method_type",
      "card"
    ],
    [
      "payment_method_subtype",
      "card"
    ],
    [
      "payment_method_data",
      Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
          "card",
          Utils$OrcaPaymentPage.getJsonFromArrayOfJson(cardBody.concat(cardBrand))
        ]])
    ]
  ];
}

export {
  updateCardBody,
  updateCVVBody,
  vaultUpdateCVVBody,
  saveCardBody,
}
/* Utils-OrcaPaymentPage Not a pure module */
